import { ACTION_TYPES } from "./actions";

const initialState = {
  scenario: null,
  currentStep: null,
  history: [],
  error: null
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_SCENARIO:
      return { ...state, scenario: action.payload };

    case ACTION_TYPES.GO_TO_NEXT_STEP: {
      if (!action.payload) return {...state};
      const newCurrentStep = state.scenario?.steps.find((item) => item.id === action.payload);
      if (!newCurrentStep) return {...state, error: `Step with id '${action.payload}' was not found.`}
      return { ...state, currentStep: newCurrentStep, history: [...state.history, newCurrentStep.id] };
    }

    case ACTION_TYPES.GO_BACK_TO_PREV_STEP: {
      const newHistory = [...state.history.slice(0, state.history.length - 1)];
      const newCurrentStepId = newHistory[newHistory.length - 1];
      const newCurrentStep = state.scenario?.steps.find((item) => item.id === newCurrentStepId);
      if (!newCurrentStep) return {...state, error: `Step with id '${action.payload}' was not found.`}
      return { ...state, currentStep: newCurrentStep, history: newHistory };
    }

    case ACTION_TYPES.RESTART:
      return { ...state, currentStep: null, history: [], error:null };

    case ACTION_TYPES.RESET:
      return { ...initialState };

    default:
      return state;
  }
};

export { initialState };

export default reducer;
